module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01_m.f5a74313cc5131a006f66ac1680a0099.png";